import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';  
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Screen = ({ id, images, texts }) => {
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const screenRef = useRef(null); 

  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
  
    if (!isMobile && imagesLoaded) {
      gsap.from('.screen img,.screen.text-box', {
        opacity: 0,
        y: 20,
        duration: 1, 
        stagger: 0.2,
        delay: 0.3,
        scrollTrigger: {
          trigger: '.screen',
          start: 'top 80%', 
          toggleActions: 'play none none reverse'
        },
        clearProps: 'opacity, transform'  
      });
    }
  }, [imagesLoaded]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      },
      {
        threshold: 0.1
      }
    );

    if (screenRef.current) {
      observer.observe(screenRef.current);
    }

    return () => {
      if (screenRef.current) {
        observer.unobserve(screenRef.current);
      }
    };
  }, []);

  return (
    <div ref={screenRef} id={id} className={`screen ${visible? 'visible' : ''}`} style={{ opacity: visible? 1 : 0, transition: 'opacity 1s', height: '100vh', position: 'relative' }}>
      <div className="content-wrapper">
        {isMobile? (
          <>
            {images.map((image, index) => (
              <div key={index} className="image-block">
                <img src={image.url} alt={image.title} className={`img ${image.className}`} style={{ maxWidth: '100%', margin: '10px 0' }} />
              </div>
            ))}
            {texts.map((text, index) => (
              <div key={index} className="text-box" style={{ position: 'static', top: 'auto', left: 'auto', width: '100%', margin: '10px 0' }}>
                {text.content}
              </div>
            ))}
          </>
        ) : (
          <>
            <div className="image-block">
              {images.map((image, index) => (
                <div key={index} className="image-block">
                  <img src={image.url} alt={image.title} className={`img ${image.className}`} style={{ maxWidth: '100%', margin: '10px 0' }} />
                </div>
              ))}
            </div>
            <div className="text-boxes">
              {texts.map((text, index) => (
                <div key={index} className="text-box" style={{ position: 'absolute', top: `${text.top}%`, left: `${text.left}%`, width: '30%', color: 'black', padding: '20px', margin: '10px', borderRadius: '10px', display: 'block',...text.style }}>
                  {text.content}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Screen;
